import * as React from 'react';
import { FormInput } from 'source/app/presentation/Shared/Form/Input/FormInput';
import { Style } from 'source/app/presentation/Shared/Styles/CSS';
import { IsHtmlSelectorValid } from '../Helpers/IsHtmlSelectorValid';

export const HtmlSelectorInput = ({
	selection,
	setSelection
}: {
	selection: string;
	setSelection: React.Dispatch<React.SetStateAction<string>>;
}) => {
	const [ warning, setWarning ] = React.useState<string | undefined>('');

	React.useEffect(
		() => {
			const isSelectorValid = IsHtmlSelectorValid(selection);

			setWarning(
				isSelectorValid
					? undefined
					: `Cannot find target element '${selection}'`
			);
		},
		[ selection ]
	);

	return (
		<span>
			<FormInput
				type="text"
				width="auto"
				value={selection}
				onChange={(event) => setSelection(event.target.value)}
			/>
			<InputWarning warning={warning} />
		</span>
	);
};

const InputWarning = ({ warning }: { warning: string | undefined }) => {
	if (!warning) {
		return null;
	}

	return (
		<span
			id="HtmlSelectorInputWarning"
			{...Style(`htmlSelectorInputWarning`, {
				color: `coral`
			})}
		>
			{warning ? warning : ''}
		</span>
	);
};
